export const styles = {
  wrapper: {
    padding: '20px 35px',
    color: '#011533',
    fontFamily: "'Proxima Nova', sans-serif",
  },
  title: {
    fontWeight: 800,
    fontSize: '32px',
  },
  text: {
    fontSize: '16px',
    color: '#979797',
    '& span': {
      color: '#011533',
    },
  },
  formColumn: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  formWrapperColumn: {
    display: 'flex',
    flexDirection: 'column',
    // marginRight: '60px',
    '& > div:first-child': {
      marginBottom: '14px',
    },
  },
  content: {
    marginTop: '48px',
  },
  cardRow: {
    display: 'flex',
    justifyContent: 'space-between',
    '& > div:first-child': {
      marginRight: '20px',
    },
    marginBottom: '20px',
  },
  card: {
    height: '236px',
    width: '100%',
    background: '#FFFFFF',
    borderRadius: '8px',
    boxShadow: '0px 4px 16px rgba(39, 55, 84, 0.10)',
    padding: '18px 6px 18px 24px',
    position: 'relative',
  },
  cardTitle: {
    color: '#011533',
    fontSize: '16px',
    fontWeight: 700,
  },
  cardForm: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginRight: '18px',
  },
  cardSelect: {
    display: 'flex',
    '& > span': {
      marginRight: '10px',
      display: 'flex',
      alignItems: 'center',
    },
    '& > div': {
      width: '245px',
      height: '36px',
    },
    '& > div > div': {
      color: '#707087',
    },
  },
  cardSearch: {
    '& > div > input': {
      fontSize: '14px',
      height: '36px',
    },
  },
  table: {
    marginTop: '14px',
    height: '152px',
    overflowY: 'scroll',

    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '5px',
      background: '#D9D9D9',
    },
  },

  tableRow: {
    display: 'flex',
    borderRadius: '4px',
    background: '#F9F9FF',
    padding: '14px 14px 14px 32px',
    marginBottom: '6px',
    marginRight: '10px',
    '& > div': {
      flex: 1,
      textAlign: 'center',
    },
    '& > div:first-child': {
      textAlign: 'left',
    },
    '& > div:last-child': {
      textAlign: 'right',
    },
  },
  rowItemMain: {
    color: '#5F5F5F',
    fontSize: '12px',
  },
  rowItemGeneral: {
    color: '#011533',
    fontSize: '12px',
    fontWeight: 600,
  },
  hint: {
    position: 'absolute',
    bottom: '-23px',
    left: 0,
    fontStyle: 'italic',
    fontSize: '13px',
  },
}
